/*
 * Bioteine. Klaviyo language tagging + native-form integration
 *
 * Detects visitor locale (EU 27 + UK + EFTA + microstates), maps to one of the
 * languages we have content for (nl/de/fr/en), and sets it on the Klaviyo
 * profile via _learnq.identify. Unsupported locales fall back to 'en'.
 *
 * Exposes window.BTKlaviyo helpers so native Shopify newsletter forms (footer +
 * bt-newsletter section) can identify + subscribe with the same tags before
 * their form submits to /contact.
 *
 * Depends on: Klaviyo onsite tracking script loaded earlier in <head>* Runs once per session (sessionStorage dedup).
 */
(function () {
  'use strict';

  /* Languages we have email templates for. Add codes here as content ships. */
  var AVAILABLE_LANGUAGES = ['nl', 'de', 'fr', 'en'];
  var FALLBACK = 'en';

  /*
  * Locale → routing-key map.
  * Keys are normalized full locales (e.g. 'de-AT') OR base-2-letter ('de').
  * Lookup tries full code first, then falls back to base, then to FALLBACK.
  */
  var LOCALE_MAP = {
  /* Dutch */
  'nl': 'nl', 'nl-NL': 'nl', 'nl-BE': 'nl', 'nl-AW': 'nl', 'nl-CW': 'nl', 'nl-SX': 'nl',

  /* German. DE, AT, CH-DE, LU-DE, LI */
  'de': 'de', 'de-DE': 'de', 'de-AT': 'de', 'de-CH': 'de', 'de-LU': 'de', 'de-LI': 'de',

  /* French. FR, BE-FR, CH-FR, LU-FR, MC */
  'fr': 'fr', 'fr-FR': 'fr', 'fr-BE': 'fr', 'fr-CH': 'fr', 'fr-LU': 'fr', 'fr-MC': 'fr',

  /* English. UK, IE, Malta, Cyprus, also catches en-US visitors */
  'en': 'en', 'en-GB': 'en', 'en-US': 'en', 'en-IE': 'en', 'en-MT': 'en', 'en-CY': 'en',

  /* Other EU/EFTA languages. Fallback to en for now */
  'es': 'en', 'es-ES': 'en',
  'pt': 'en', 'pt-PT': 'en',
  'it': 'en', 'it-IT': 'en', 'it-CH': 'en', 'it-SM': 'en', 'it-VA': 'en',
  'pl': 'en', 'pl-PL': 'en',
  'sv': 'en', 'sv-SE': 'en', 'sv-FI': 'en',
  'da': 'en', 'da-DK': 'en',
  'no': 'en', 'nb': 'en', 'nn': 'en', 'nb-NO': 'en', 'nn-NO': 'en',
  'fi': 'en', 'fi-FI': 'en',
  'is': 'en', 'is-IS': 'en',
  'cs': 'en', 'cs-CZ': 'en',
  'sk': 'en', 'sk-SK': 'en',
  'sl': 'en', 'sl-SI': 'en',
  'hu': 'en', 'hu-HU': 'en',
  'ro': 'en', 'ro-RO': 'en',
  'bg': 'en', 'bg-BG': 'en',
  'hr': 'en', 'hr-HR': 'en',
  'et': 'en', 'et-EE': 'en',
  'lv': 'en', 'lv-LV': 'en',
  'lt': 'en', 'lt-LT': 'en',
  'mt': 'en', 'mt-MT': 'en',
  'el': 'en', 'el-GR': 'en', 'el-CY': 'en',
  'ga': 'en', 'ga-IE': 'en',
  'lb': 'en', 'lb-LU': 'en',
  'rm': 'en', 'rm-CH': 'en'
  };

  function normalizeLocale(loc) {
  if (!loc || typeof loc !== 'string') return '';
  var parts = loc.replace('_', '-').split('-');
  if (parts.length === 1) return parts[0].toLowerCase();
  return parts[0].toLowerCase() + '-' + parts[1].toUpperCase();
  }

  function detectLocale() {
  /* 1. Shopify storefront locale. Best signal */
  try {
  if (window.Shopify && window.Shopify.locale) {
  return normalizeLocale(window.Shopify.locale);
  }
  } catch (e) {}

  /* 2. Shopify country + browser language (handles BE: nl-BE vs fr-BE) */
  try {
  if (window.Shopify && window.Shopify.country && navigator.language) {
  var lang = navigator.language.split('-')[0].toLowerCase();
  return lang + '-' + window.Shopify.country.toUpperCase();
  }
  } catch (e) {}

  /* 3. <html lang=".."> attribute */
  try {
  var htmlLang = document.documentElement.lang;
  if (htmlLang) return normalizeLocale(htmlLang);
  } catch (e) {}

  /* 4. Browser navigator.language */
  try {
  if (navigator.language) return normalizeLocale(navigator.language);
  } catch (e) {}

  return '';
  }

  function mapToContentLanguage(locale) {
  if (!locale) return FALLBACK;
  if (LOCALE_MAP[locale]) return LOCALE_MAP[locale];
  var base = locale.split('-')[0].toLowerCase();
  if (LOCALE_MAP[base]) return LOCALE_MAP[base];
  return FALLBACK;
  }

  /*
  * Compute current nurture entry chapter (A-F) from today's date.
  * Chapter windows (NL calendar): all 6 chapters span ~2 months.
  * The chapter property is read by the 6 seasonal nurture flows in Klaviyo. * each flow filters on `nurture_entry_chapter` to route profiles to the
  * right starting point so a May signup starts in voor-zomer (B), not in
  * vroege lente (A).
  */
  function currentNurtureChapter() {
  var d = new Date();
  var monthDay = (d.getMonth() + 1) * 100 + d.getDate();
  if (monthDay >= 215 && monthDay < 415) return 'A'; /* 15 feb. 15 apr */
  if (monthDay >= 415 && monthDay < 615) return 'B'; /* 15 apr. 15 jun */
  if (monthDay >= 615 && monthDay < 815) return 'C'; /* 15 jun. 15 aug */
  if (monthDay >= 815 && monthDay < 1015) return 'D'; /* 15 aug. 15 okt */
  if (monthDay >= 1015 && monthDay < 1215) return 'E'; /* 15 okt. 15 dec */
  return 'F'; /* 15 dec. 15 feb (wraps) */
  }

  function identifyKlaviyo(language, detectedLocale) {
  var queue = window._learnq = window._learnq || [];
  var payload = {
  'language': language,
  'nurture_entry_chapter': currentNurtureChapter()
  };
  if (detectedLocale) payload['detected_locale'] = detectedLocale;
  queue.push(['identify', payload]);
  }

  function shouldFire() {
  try {
  var detected = detectLocale();
  var key = 'lang:' + detected;
  if (sessionStorage.getItem('bt_klaviyo_lang_fired') === key) {
  return false;
  }
  sessionStorage.setItem('bt_klaviyo_lang_fired', key);
  return true;
  } catch (e) {
  /* Private mode or storage blocked. Just always run; identify is idempotent. */
  return true;
  }
  }

  /* Klaviyo company id, hard-coded. Matches the onsite tracker. */
  var KLAVIYO_COMPANY_ID = 'Lfwr6A';

  /* The newsletter list. Bioteine. Nieuwsbrief. */
  var NEWSLETTER_LIST_IDS = {
    nl: 'Vimpgz',   /* Bioteine. Nieuwsbrief (NL) */
    de: 'ULCFcG',   /* Nieuwsbrief DE (Duits) */
    en: 'X7skYq',   /* Nieuwsbrief EN (Engels) */
    fr: 'SgyuJc'    /* Nieuwsbrief FR (Frans) */
  };
  var NEWSLETTER_LIST_ID = 'Vimpgz'; /* legacy fallback */
  function newsletterListFor(language) {
    return NEWSLETTER_LIST_IDS[language] || NEWSLETTER_LIST_ID;
  }

  /* Expose helpers so native Shopify forms (footer/newsletter) can identify on submit. */
  window.BTKlaviyo = window.BTKlaviyo || {};
  window.BTKlaviyo.detectLocale = detectLocale;
  window.BTKlaviyo.mapToContentLanguage = mapToContentLanguage;

  /* Legacy identify-only path. Kept for cases that only need property update
  * (no consent change). Most signups should use subscribeAndIdentify below. */
  window.BTKlaviyo.identifyAndSubscribe = function (email, source) {
  if (!email) return;
  var detected = detectLocale();
  var language = mapToContentLanguage(detected);
  var queue = window._learnq = window._learnq || [];
  queue.push(['identify', {
  '$email': email,
  'language': language,
  'detected_locale': detected,
  'signup_source': source || 'unknown',
  'nurture_entry_chapter': currentNurtureChapter()
  }]);
  };

  /**
  * subscribeAndIdentify(email, properties, source)
  *
  * Creates / updates a Klaviyo profile, sets all properties, AND explicitly
  * subscribes the email channel for marketing consent. Profile is added to
  * the newsletter list, which triggers any list-trigger flows.
  *
  * Without this, profiles land as "Never subscribed" and no flow email will
  * deliver to them. Even though all properties + events are correct.
  *
  * @param {string} email. Required
  * @param {object} properties. Coach_*, etc. Anything you'd normally pass to identify
  * @param {string} source. For custom_source attribution: 'popup', 'footer', 'fase-test', etc.
  * @return {Promise} resolves with fetch Response
  */
  window.BTKlaviyo.subscribeAndIdentify = function (email, properties, source) {
  if (!email) return Promise.reject(new Error('email required'));
  var detected = detectLocale();
  var language = mapToContentLanguage(detected);

  var mergedProps = Object.assign({
  'language': language,
  'detected_locale': detected,
  'signup_source': source || 'unknown',
  'nurture_entry_chapter': currentNurtureChapter()
  }, properties || {});

  var body = {
  data: {
  type: 'subscription',
  attributes: {
  custom_source: source || 'web',
  profile: {
  data: {
  type: 'profile',
  attributes: {
  email: email,
  properties: mergedProps,
  subscriptions: {
  email: {
  marketing: {
  consent: 'SUBSCRIBED'
  }
  }
  }
  }
  }
  }
  },
  relationships: {
  list: {
  data: { type: 'list', id: newsletterListFor(language) }
  }
  }
  }
  };

  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
  method: 'POST',
  headers: {
  'revision': '2024-10-15',
  'content-type': 'application/json'
  },
  body: JSON.stringify(body)
  });
  };

  function init() {
  if (!shouldFire()) return;
  var detected = detectLocale();
  var content = mapToContentLanguage(detected);
  identifyKlaviyo(content, detected);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
  init();
  } else {
  window.addEventListener('DOMContentLoaded', init);
  }
})();
